var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeightMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 12.2H21.4545C21.7636 12.2 22 11.94 22 11.6C22 11.26 21.7636 11 21.4545 11H14.5455C14.2364 11 14 11.26 14 11.6C14 11.94 14.2364 12.2 14.5455 12.2Z",
    fill: "#85909F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99783 19.219C5.76304 18.9905 5.3913 18.9905 5.17609 19.219C4.9413 19.4476 4.9413 19.8095 5.17609 20.019L9.08913 23.8286C9.20652 23.9429 9.36304 24 9.5 24C9.63696 24 9.79348 23.9429 9.91087 23.8286L13.8239 20.019C14.0587 19.7905 14.0587 19.4286 13.8239 19.219C13.5891 18.9905 13.2174 18.9905 13.0022 19.219L10.087 22.0571V1.94286L13.0022 4.78095C13.1196 4.89524 13.2761 4.95238 13.413 4.95238C13.55 4.95238 13.7065 4.89524 13.8239 4.78095C14.0587 4.55238 14.0587 4.19048 13.8239 3.98095L9.91087 0.171429C9.67609 -0.0571429 9.30435 -0.0571429 9.08913 0.171429L5.17609 3.98095C4.9413 4.20952 4.9413 4.57143 5.17609 4.78095C5.41087 5.00952 5.78261 5.00952 5.99783 4.78095L8.91304 1.94286V22.0381L5.99783 19.219Z",
    fill: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightMinus);
export default __webpack_public_path__ + "static/media/heightMinus.849893e0f0db474f654641dd6c660c4e.svg";
export { ForwardRef as ReactComponent };